import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => (
  <>
    <Helmet>
      <title>Privacy Policy | Platform Engineering | Fepsec</title>
    </Helmet>
    <div className="container mx-auto py-16 px-4">
      <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">Your privacy is important to us. This policy explains how we collect, use, and protect your personal information when you interact with our services and website.</p>
      <ul className="list-disc ml-6 mb-4">
        <li>We collect only necessary information for service delivery</li>
        <li>Your data is never sold to third parties</li>
        <li>We use industry-standard security measures</li>
        <li>You may request data deletion at any time</li>
      </ul>
      <p>Contact us for any privacy-related questions or concerns.</p>
    </div>
  </>
);

export default PrivacyPolicy;
